import { useEffect } from 'react'

export const useSetDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = `IPS | ${title}`
    return () => {
      document.title = 'IPS'
    }
  }, [title])
}
